export default class ArchiveProducts {
    constructor(element) {
        this.root = element
        this.navigationToggler = this.root.querySelector('.products-content-mobile-filters')
        this.navigationMobile = this.root.querySelector('.products-sidebar')
        this.navigationMobileClose = this.root.querySelector('.sidebar-mobile-navigation')

        // Click navigation toggler
        if (this.navigationToggler) {
            this.navigationToggler.addEventListener('click', () => this.handleNavigationTogglerClick())
        }

        // Click on mobile navigation
        if (this.navigationMobile) {
            this.navigationMobile.addEventListener('click', (event) => this.handleNavigationMobileClick(event))
        }

        // Click on mobile close button
        if (this.navigationMobileClose) {
            this.navigationMobileClose.addEventListener('click', () => this.handleNavigationTogglerClick())
        }
    }

    handleNavigationTogglerClick() {
        this.navigationMobile.classList.toggle('toggle')
        document.querySelector('body').classList.toggle('noscroll')
    }

    handleNavigationMobileClick(event) {
        const target = event.target
        if (target && target.classList.contains('products-sidebar')) {
            this.navigationMobile.classList.toggle('toggle')
            document.querySelector('body').classList.toggle('noscroll')
        }

    }
}